"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.array.find");
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.from");
var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es7.object.values");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _menuTemplate = require("@/api/goods/menuTemplate");
var _dishGroup = require("@/api/goods/dishGroup");
var _goods = require("@/api/goods/goods");
var _goods_activity_combo = require("@/api/goods_activity/goods_activity_combo");
var _storeMenuDialog = _interopRequireDefault(require("../component/storeMenuDialog.vue"));
var _sortablejs = _interopRequireWildcard(require("sortablejs"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _fileSaver = require("file-saver");
var _methods; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
var _default = exports.default = {
  name: 'detail',
  props: ['templateId'],
  components: {
    draggable: _vuedraggable.default,
    SwPage: _SwPage.default,
    storeMenuDialog: _storeMenuDialog.default
  },
  directives: {
    waves: _waves.default
  },
  watch: {
    'syncMenuForm.source': function syncMenuFormSource(newVal) {
      if (!newVal.length) {
        // 如果源被清空，也清空目标
        this.syncMenuForm.to = [];
      } else {
        // 如果源改变了，移除目标中与新源冲突的选项
        this.syncMenuForm.to = this.syncMenuForm.to.filter(function (item) {
          return item !== newVal[0];
        });
      }
    }
  },
  data: function data() {
    return {
      listLoading: false,
      resPath: process.env.VUE_IMAGE_PATH,
      selectScene: null,
      selectGroup: null,
      selectedScenes: [],
      // 控制场景显示的多选数组
      baseInfo: {
        checkedScene: []
      },
      dishGroups: [],
      templateGroupItems: [],
      groupAddVisible: false,
      groupAddQuery: {
        page: 1,
        limit: 1000,
        keywords: null
      },
      groupAddData: [],
      itemTotal: 0,
      itemAddVisible: false,
      itemAddQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        dataType: 'templateGroupItem',
        dataId: null
      },
      itemAddTotal: 0,
      itemAddData: [],
      fullscreenLoading: false,
      selectedItemsMap: {},
      // 用于存储每个表格的选中项
      isAllSelected: false,
      // 是否全选状态
      syncMenuVisible: false,
      syncMenuForm: {
        id: null,
        source: [],
        to: []
      },
      storeMenuVisible: false,
      storeMenuForm: {
        storeScope: 1,
        relatedStoreIdList: []
      },
      regionStoreList: [],
      // 指定区域门店
      editGroupItemForm: {
        beginTimeStr: null,
        endTimeStr: null
      },
      editGroupItemVisible: false,
      weekdays: [{
        label: '周一',
        value: 1
      }, {
        label: '周二',
        value: 2
      }, {
        label: '周三',
        value: 3
      }, {
        label: '周四',
        value: 4
      }, {
        label: '周五',
        value: 5
      }, {
        label: '周六',
        value: 6
      }, {
        label: '周日',
        value: 7
      }],
      // 编辑模板相关
      editTemplateVisible: false,
      editTemplateForm: {
        id: null,
        name: '',
        type: 1
      },
      editTemplateRules: {
        name: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'blur'
        }]
      },
      // 预览相关
      previewDialogVisible: false,
      previewQrCode: '',
      previewLoading: false,
      downloadAllLoading: false,
      totalQrCodeLoading: false,
      totalQrCode: '',
      // 按需加载相关
      loadedGroupIds: new Set(),
      // 已加载详情的分组ID集合
      observer: null,
      // Intersection Observer实例
      loadingGroupDetails: false,
      // 是否正在加载分组详情
      loadingGroupIdsMap: {},
      // 每个分组的加载状态 Map<groupId, boolean>
      selectedItemIds: new Set(),
      // 集中管理选中的商品ID，避免懒加载时状态丢失
      scrollContainer: null,
      // 滚动容器DOM引用
      sortableInstances: {},
      // 跟踪每个分组的 Sortable 实例 Map<groupId, Sortable>
      isDragging: false // 防止重复触发拖动事件
    };
  },
  created: function created() {
    this.getBaseInfo();
    this.queryRegionStoreList();
    this.syncMenuForm.id = this.templateId;
  },
  beforeDestroy: function beforeDestroy() {
    var _this = this;
    // 清理Intersection Observer
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    // 清理所有 Sortable 实例
    Object.keys(this.sortableInstances).forEach(function (groupId) {
      if (_this.sortableInstances[groupId]) {
        _this.sortableInstances[groupId].destroy();
      }
    });
    this.sortableInstances = {};
  },
  mounted: function mounted() {
    var _this2 = this;
    // 不再在mounted时初始化所有表格的拖拽，改为按需初始化

    // 开发模式下，将调试方法暴露到全局，方便在控制台调用
    if (process.env.NODE_ENV === 'development') {
      window.debugMenuTemplateLoading = function () {
        return _this2.debugLoadingStatus();
      };
      // console.log('调试提示: 在控制台输入 debugMenuTemplateLoading() 可查看懒加载状态');
    }
  },
  computed: {
    // 获取所有选中的项
    allSelectedItems: function allSelectedItems() {
      return Object.values(this.selectedItemsMap).flat();
    },
    // 将分组数据转换为树形结构
    treeData: function treeData() {
      return [{
        id: 'all',
        groupName: '全部',
        children: this.dishGroups || []
      }];
    },
    // 编辑明细时结束时间选择器的配置
    editGroupItemEndTimeOptions: function editGroupItemEndTimeOptions() {
      var beginTime = this.editGroupItemForm.beginTimeStr;
      if (!beginTime) {
        return {
          selectableRange: '00:00:00 - 23:59:00'
        };
      }
      // 将 HH:mm 格式转换为 HH:mm:ss
      var beginTimeWithSeconds = beginTime + ':00';
      return {
        selectableRange: "".concat(beginTimeWithSeconds, " - 23:59:00")
      };
    },
    // 编辑模板时结束时间选择器的配置
    editTemplateEndTimeOptions: function editTemplateEndTimeOptions() {
      var beginTime = this.editTemplateForm.beginTimeStr;
      if (!beginTime) {
        return {
          selectableRange: '00:00:00 - 23:59:00'
        };
      }
      // 将 HH:mm 格式转换为 HH:mm:ss
      var beginTimeWithSeconds = beginTime + ':00';
      return {
        selectableRange: "".concat(beginTimeWithSeconds, " - 23:59:00")
      };
    }
  },
  methods: (_methods = {
    // 初始化Intersection Observer（修复：使用正确的滚动容器作为root）
    initIntersectionObserver: function initIntersectionObserver() {
      var _this3 = this;
      // 清理旧的observer
      if (this.observer) {
        this.observer.disconnect();
      }

      // 获取滚动容器（右侧的 .group-block-container）
      this.$nextTick(function () {
        _this3.scrollContainer = document.querySelector('.group-block-container');
        if (!_this3.scrollContainer) {
          // console.warn('未找到滚动容器 .group-block-container');
          return;
        }

        // 创建新的Intersection Observer，使用滚动容器作为root
        _this3.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // 获取分组ID
              var groupId = _this3.extractGroupIdFromElement(entry.target);
              if (groupId && !_this3.loadedGroupIds.has(groupId)) {
                // console.log(`加载分组 ${groupId} 的详情`);
                _this3.loadGroupDetails(groupId);
              }
            }
          });
        }, {
          root: _this3.scrollContainer,
          // 使用滚动容器作为root
          rootMargin: '200px',
          // 提前200px开始加载（给容器内滚动更多缓冲）
          threshold: 0.01 // 1%可见时触发（更灵敏）
        });

        // 监听所有分组块
        _this3.templateGroupItems.forEach(function (detail) {
          var element = document.getElementById("group-block-".concat(detail.id));
          if (element) {
            _this3.observer.observe(element);
            // console.log(`开始监听分组 ${detail.id}`);
          } else {
            // console.warn(`未找到分组 ${detail.id} 的DOM元素`);
          }
        });

        // console.log(`Intersection Observer 初始化完成，正在监听 ${this.templateGroupItems.length} 个分组`);
      });
    },
    // 从DOM元素中提取分组ID
    extractGroupIdFromElement: function extractGroupIdFromElement(element) {
      var id = element.id;
      if (id && id.startsWith('group-block-')) {
        return parseInt(id.replace('group-block-', ''));
      }
      return null;
    },
    // 加载分组详情（按分组级别的懒加载）
    loadGroupDetails: function loadGroupDetails(groupId) {
      var _this4 = this;
      if (this.loadedGroupIds.has(groupId) || this.loadingGroupIdsMap[groupId]) {
        // console.log(`分组 ${groupId} 已加载或正在加载中，跳过`);
        return;
      }

      // console.log(`开始加载分组 ${groupId} 的详情...`);
      // 设置当前分组的加载状态
      this.$set(this.loadingGroupIdsMap, groupId, true);
      (0, _menuTemplate.getGroupItemDetails)(groupId).then(function (res) {
        // console.log('分组 ' + groupId + ' 详情加载成功，商品数量:', (res.data.items && res.data.items.length) || 0);
        // 更新对应分组的数据
        var groupIndex = _this4.templateGroupItems.findIndex(function (d) {
          return d.id === groupId;
        });
        if (groupIndex !== -1) {
          _this4.$set(_this4.templateGroupItems, groupIndex, res.data);
          _this4.loadedGroupIds.add(groupId);

          // 为该分组初始化拖拽
          _this4.$nextTick(function () {
            _this4.initDraggableForTable(res.data);

            // 恢复选中状态
            var tableRef = _this4.$refs["table_".concat(groupId)];
            if (tableRef && tableRef.length > 0 && res.data.items) {
              res.data.items.forEach(function (row) {
                if (_this4.selectedItemIds.has(row.id)) {
                  tableRef[0].toggleRowSelection(row, true);
                }
              });
            }
          });
        } else {
          // console.warn(`未找到分组 ${groupId} 在 templateGroupItems 中的索引`);
        }
      }).catch(function (err) {
        console.error("\u52A0\u8F7D\u5206\u7EC4 ".concat(groupId, " \u8BE6\u60C5\u5931\u8D25:"), err);
        _this4.$message.error("\u52A0\u8F7D\u5206\u7EC4 ".concat(groupId, " \u8BE6\u60C5\u5931\u8D25"));
      }).finally(function () {
        // 清除当前分组的加载状态
        _this4.$set(_this4.loadingGroupIdsMap, groupId, false);
        // console.log(`分组 ${groupId} 加载完成`);
      });
    },
    /**
     * 重新加载单个分组的详情数据
     * 不影响其他分组的懒加载状态
     * @param {number} groupId - 需要刷新的分组ID
     * @param {boolean} reinitSortable - 是否重新初始化 Sortable（默认 false）
     */
    reloadSingleGroupDetail: function reloadSingleGroupDetail(groupId) {
      var _this5 = this;
      var reinitSortable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // 防止重复加载
      if (this.loadingGroupIdsMap[groupId]) {
        // console.log(`分组 ${groupId} 正在加载中，跳过`);
        return;
      }

      // console.log(`重新加载分组 ${groupId} 的详情...`);
      // 设置加载状态
      this.$set(this.loadingGroupIdsMap, groupId, true);

      // 调用 API 获取分组详情
      (0, _menuTemplate.getGroupItemDetails)(groupId).then(function (res) {
        // console.log(`分组 ${groupId} 详情刷新成功，商品数量:`, (res.data.items && res.data.items.length) || 0);
        // console.log(`服务器返回的商品顺序:`, res.data.items.map(i => i.id));

        // 找到分组在列表中的索引
        var groupIndex = _this5.templateGroupItems.findIndex(function (d) {
          return d.id === groupId;
        });
        if (groupIndex !== -1) {
          // 更新分组数据
          // console.log(`更新前 templateGroupItems[${groupIndex}].items 顺序:`, this.templateGroupItems[groupIndex].items.map(i => i.id));
          _this5.$set(_this5.templateGroupItems, groupIndex, res.data);
          // console.log(`更新后 templateGroupItems[${groupIndex}].items 顺序:`, this.templateGroupItems[groupIndex].items.map(i => i.id));

          // 保持已加载状态（不清空其他分组的 loadedGroupIds）
          _this5.loadedGroupIds.add(groupId);

          // 只有在需要时才重新初始化 Sortable（避免回弹）
          if (reinitSortable) {
            _this5.$nextTick(function () {
              // 再等一帧，确保 DOM 完全稳定
              _this5.$nextTick(function () {
                _this5.initDraggableForTable(res.data);

                // 恢复选中状态
                var tableRef = _this5.$refs["table_".concat(groupId)];
                if (tableRef && tableRef.length > 0 && res.data.items) {
                  res.data.items.forEach(function (row) {
                    if (_this5.selectedItemIds.has(row.id)) {
                      tableRef[0].toggleRowSelection(row, true);
                    }
                  });
                }
              });
            });
          } else {
            // 即使不重新初始化 Sortable，也要恢复选中状态
            _this5.$nextTick(function () {
              var tableRef = _this5.$refs["table_".concat(groupId)];
              if (tableRef && tableRef.length > 0 && res.data.items) {
                res.data.items.forEach(function (row) {
                  if (_this5.selectedItemIds.has(row.id)) {
                    tableRef[0].toggleRowSelection(row, true);
                  }
                });
              }
            });
          }
        } else {
          // console.warn(`未找到分组 ${groupId} 在 templateGroupItems 中的索引`);
        }
      }).catch(function (err) {
        console.error("\u91CD\u65B0\u52A0\u8F7D\u5206\u7EC4 ".concat(groupId, " \u8BE6\u60C5\u5931\u8D25:"), err);
        _this5.$message.error("\u5237\u65B0\u5206\u7EC4 ".concat(groupId, " \u5931\u8D25"));
      }).finally(function () {
        // 清除加载状态
        _this5.$set(_this5.loadingGroupIdsMap, groupId, false);
        // console.log(`分组 ${groupId} 刷新完成`);
      });
    },
    handleUpdateGroupItem: function handleUpdateGroupItem() {
      var _this6 = this;
      // 仅分时模板才需要验证时间
      // 从 baseInfo 获取模板类型
      var templateType = this.baseInfo.type;
      if (templateType == 2 && this.editGroupItemForm.beginTimeStr && this.editGroupItemForm.endTimeStr) {
        if (this.editGroupItemForm.endTimeStr <= this.editGroupItemForm.beginTimeStr) {
          this.$message.error('结束时间必须大于开始时间');
          return;
        }
      }
      this.listLoading = true;
      (0, _menuTemplate.saveGroupItem)(this.editGroupItemForm).then(function (res) {
        _this6.listLoading = false;
        if (res.code === 0 || res.code === 200) {
          _this6.$message.success('操作成功');
          // 优化：只刷新该商品所在的分组
          var groupId = _this6.editGroupItemForm.templateGroupId;
          if (groupId) {
            _this6.reloadSingleGroupDetail(groupId);
          } else {
            console.error('无法获取商品所属分组ID，templateGroupId 为空');
            _this6.$message.error('刷新失败：缺少分组信息');
          }
          // 关闭编辑对话框
          _this6.editGroupItemVisible = false;
        } else {
          _this6.$message.error(res.msg || '操作失败');
        }
      }).catch(function () {
        _this6.listLoading = false;
        _this6.$message.error('操作失败');
      });
    },
    handleGroupItemEdit: function handleGroupItemEdit(row) {
      this.editGroupItemForm = row;
      this.editGroupItemVisible = true;
    },
    // 编辑模板
    handleEditTemplate: function handleEditTemplate() {
      var _this7 = this;
      (0, _menuTemplate.getById)(this.templateId).then(function (res) {
        _this7.editTemplateForm = res.data;
        _this7.editTemplateVisible = true;
      });
    },
    // 保存模板
    handleSaveTemplate: function handleSaveTemplate() {
      var _this8 = this;
      this.$refs.editTemplateFormRef.validate(function (valid) {
        if (valid) {
          // 验证时间（仅分时模板需要验证）
          if (_this8.editTemplateForm.type == 2 && _this8.editTemplateForm.beginTimeStr && _this8.editTemplateForm.endTimeStr) {
            if (_this8.editTemplateForm.endTimeStr <= _this8.editTemplateForm.beginTimeStr) {
              _this8.$message.error('结束时间必须大于开始时间');
              return;
            }
          }

          // 如果是分时模板，需要验证影响
          if (_this8.editTemplateForm.type == 2) {
            _this8.validateTemplateTime().then(function (message) {
              if (message) {
                // 有冲突，显示确认对话框
                _this8.$confirm(message, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(function () {
                  _this8.doSaveTemplate();
                }).catch(function () {});
              } else {
                // 无冲突，直接保存
                _this8.doSaveTemplate();
              }
            }).catch(function () {
              _this8.$message.error('验证失败，请重试');
            });
          } else {
            // 非分时模板，直接保存
            _this8.$confirm('确认提交吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(function () {
              _this8.doSaveTemplate();
            }).catch(function () {});
          }
        }
      });
    },
    // 执行保存模板
    doSaveTemplate: function doSaveTemplate() {
      var _this9 = this;
      (0, _menuTemplate.save)(this.editTemplateForm).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this9.$message.success('操作成功');
          _this9.editTemplateVisible = false;
          _this9.getBaseInfo();
        } else {
          _this9.$message.error(res.msg || '保存失败');
        }
      }).catch(function () {
        _this9.$message.error('保存失败');
      });
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.editGroupItemForm.checkedWeekdays = val ? [1, 2, 3, 4, 5, 6, 7] : [];
    },
    handleBeginTimeChange: function handleBeginTimeChange() {
      // 仅分时模板才需要验证时间
      var templateType = this.baseInfo.type;
      if (templateType != 2) {
        return;
      }
      // 当开始时间改变时，如果结束时间小于等于开始时间，则清空结束时间
      if (this.editGroupItemForm.beginTimeStr && this.editGroupItemForm.endTimeStr) {
        if (this.editGroupItemForm.endTimeStr <= this.editGroupItemForm.beginTimeStr) {
          this.editGroupItemForm.endTimeStr = null;
          this.$message.warning('结束时间必须大于开始时间');
        }
      }
    },
    handleTemplateBeginTimeChange: function handleTemplateBeginTimeChange() {
      // 当模板开始时间改变时，如果结束时间小于等于开始时间，则清空结束时间
      if (this.editTemplateForm.beginTimeStr && this.editTemplateForm.endTimeStr) {
        if (this.editTemplateForm.endTimeStr <= this.editTemplateForm.beginTimeStr) {
          this.editTemplateForm.endTimeStr = null;
          this.$message.warning('结束时间必须大于开始时间');
        }
      }
    },
    // 验证门店选择
    validateStoreMenu: function validateStoreMenu(storeIds) {
      var _this0 = this;
      return new Promise(function (resolve) {
        (0, _menuTemplate.checkApplyStore)({
          storeIds: storeIds,
          id: _this0.templateId
        }).then(function (res) {
          var message = '';
          if (res.data.length > 0) {
            for (var i = 0; i < res.data.length; i++) {
              message += res.data[i] + '\n';
            }
          }
          message += '确认执行操作吗?';
          resolve(message);
        });
      });
    },
    // 验证分时模板时间选择
    validateTemplateTime: function validateTemplateTime() {
      var _this1 = this;
      return new Promise(function (resolve, reject) {
        // 准备请求参数，直接传递时间字符串，让后端解析
        var params = {
          id: _this1.editTemplateForm.id,
          type: _this1.editTemplateForm.type
        };

        // 直接传递时间字符串，后端会使用 SimpleDateFormat("HH:mm") 解析
        if (_this1.editTemplateForm.beginTimeStr) {
          params.beginTimeStr = _this1.editTemplateForm.beginTimeStr;
        }
        if (_this1.editTemplateForm.endTimeStr) {
          params.endTimeStr = _this1.editTemplateForm.endTimeStr;
        }
        // 转换星期数组为位运算值
        if (_this1.editTemplateForm.checkedWeekdays && _this1.editTemplateForm.checkedWeekdays.length > 0) {
          params.weekdays = _this1.editTemplateForm.checkedWeekdays.reduce(function (acc, day) {
            return acc | 1 << day - 1;
          }, 0);
        }
        (0, _menuTemplate.checkTemplateTime)(params).then(function (res) {
          var message = '';
          if (res.data && res.data.length > 0) {
            for (var i = 0; i < res.data.length; i++) {
              message += res.data[i] + '\n';
            }
            message += '确认执行操作吗?';
            resolve(message);
          } else {
            resolve(null); // 无冲突
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    // 保存门店设置
    handleSaveStoreMenu: function handleSaveStoreMenu(data) {
      var _this10 = this;
      this.listLoading = true;
      (0, _menuTemplate.changeApplyStore)({
        storeIds: data.relatedStoreIdList,
        id: this.templateId
      }).then(function (res) {
        _this10.storeMenuVisible = false;
        _this10.listLoading = false;
        _this10.$message.success('操作成功');
        _this10.$emit('store-menu-changed'); // 如果需要通知父组件
      }).catch(function () {
        _this10.listLoading = false;
      });
    },
    // 处理门店菜单弹窗关闭
    handleStoreMenuClose: function handleStoreMenuClose() {
      // 可以在这里做一些清理工作
    },
    handleStoreMenu: function handleStoreMenu() {
      var _this11 = this;
      (0, _menuTemplate.getApplyStore)({
        id: this.templateId
      }).then(function (res) {
        // 这里只需要设置表单数据，不需要打开弹窗（由组件控制）
        _this11.storeMenuForm.relatedStoreIdList = res.data;
        _this11.storeMenuVisible = true;
      });
    },
    queryRegionStoreList: function queryRegionStoreList() {
      var _this12 = this;
      (0, _goods_activity_combo.queryRegionStoreList)().then(function (res) {
        var data = res.data;
        if (data) {
          _this12.regionStoreList = data.storeRegions || [];
        }
      });
    }
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "handleStoreMenu", function handleStoreMenu() {
    var _this13 = this;
    (0, _menuTemplate.getApplyStore)({
      id: this.templateId
    }).then(function (res) {
      _this13.storeMenuForm.relatedStoreIdList = res.data;
      _this13.storeMenuVisible = true;
    });
  }), "syncMenu", function syncMenu() {
    var _this14 = this;
    this.$confirm('同步后会将对应门店菜单全部覆盖，确定执行吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      _this14.listLoading = true;
      (0, _menuTemplate.syncMenu)(_this14.syncMenuForm).then(function (res) {
        _this14.listLoading = false;
        if (res.code === 0 || res.code === 200) {
          // 检查响应状态，如果任务已创建，提示用户在后台执行
          if (res.data && res.data.status === 'created') {
            _this14.$message.success('同步任务已在后台运行，可在任务管理中查看进度');
          } else if (res.data && res.data.status === 'exists_running') {
            _this14.$message.warning(res.data.message || '同步任务正在执行中，请勿重复操作');
          } else {
            _this14.$message.success('同步任务已在后台运行，可在任务管理中查看进度');
          }
          _this14.syncMenuVisible = false;
        } else {
          _this14.$message.error(res.msg || '同步失败');
        }
      }).catch(function () {
        _this14.listLoading = false;
        _this14.$message.error('同步失败');
      });
    }).catch(function () {});
  }), "getSceneLabel", function getSceneLabel(scene) {
    var sceneMap = {
      1: '堂食',
      2: '自提',
      3: '外卖'
    };
    return sceneMap[scene] || '';
  }), "initTableDraggable", function initTableDraggable() {
    var _this15 = this;
    // 在组件挂载后初始化拖拽功能
    this.$nextTick(function () {
      _this15.templateGroupItems.forEach(function (detail) {
        _this15.initDraggableForTable(detail);
      });
    });
  }), "initDraggableForTable", function initDraggableForTable(detail) {
    var _this16 = this;
    this.$nextTick(function () {
      var tableRef = _this16.$refs["table_".concat(detail.id)];
      if (tableRef && tableRef.length > 0) {
        var el = tableRef[0].$el.querySelector('.el-table__body-wrapper tbody');
        if (el) {
          // 销毁已存在的 Sortable 实例（如果有）
          if (_this16.sortableInstances[detail.id]) {
            // console.log(`销毁分组 ${detail.id} 的旧 Sortable 实例`);
            _this16.sortableInstances[detail.id].destroy();
            delete _this16.sortableInstances[detail.id];
          }

          // 检查是否有多个 tbody
          var tbodies = tableRef[0].$el.querySelectorAll('.el-table__body-wrapper tbody');
          // console.log(`分组 ${detail.id} 的 tbody 数量:`, tbodies.length);
          if (tbodies.length > 1) {
            // console.warn('警告：检测到多个 tbody，可能导致 Sortable 冲突！');
          }

          // console.log(`为分组 ${detail.id} 创建新的 Sortable 实例，DOM元素:`, el);

          // 创建新的 Sortable 实例并保存引用
          var sortableInstance = new _sortablejs.default(el, {
            animation: 150,
            // 恢复平滑的拖动动画
            handle: '.el-icon-rank',
            ghostClass: 'sortable-ghost',
            // 拖动时的样式
            chosenClass: 'sortable-chosen',
            // 选中时的样式
            dragClass: 'sortable-drag',
            // 拖动中的样式
            fallbackOnBody: true,
            // 拖动时克隆元素放到 body 中
            swapThreshold: 0.65,
            forceFallback: false,
            // 使用原生拖拽，保持表格行样式
            onEnd: function onEnd(evt) {
              var oldIndex = evt.oldIndex,
                newIndex = evt.newIndex;

              // 防止重复触发
              if (_this16.isDragging) {
                return;
              }
              _this16.isDragging = true;

              // 只有位置真正改变时才处理
              if (oldIndex !== newIndex) {
                var groupIndex = _this16.templateGroupItems.findIndex(function (d) {
                  return d.id === detail.id;
                });
                if (groupIndex !== -1) {
                  var items = _this16.templateGroupItems[groupIndex].items;

                  // 先从数组中移除被拖动的元素
                  var _items$splice = items.splice(oldIndex, 1),
                    _items$splice2 = (0, _slicedToArray2.default)(_items$splice, 1),
                    movedItem = _items$splice2[0];

                  // 插入到新位置
                  items.splice(newIndex, 0, movedItem);

                  // 保存到服务器
                  var itemIds = items.map(function (i) {
                    return i.id;
                  });
                  (0, _menuTemplate.saveGroupItemSort)({
                    ids: itemIds
                  }).then(function (res) {
                    if (res.code === 0 || res.code === 200) {
                      _this16.$message.success('排序保存成功');

                      // 清空当前分组数据
                      _this16.$set(_this16.templateGroupItems[groupIndex], 'items', []);

                      // 重新拉取分组数据
                      _this16.reloadSingleGroupDetail(detail.id, true);
                    } else {
                      _this16.$message.error(res.msg || '排序保存失败');
                      // 保存失败时重新拉取原数据
                      _this16.reloadSingleGroupDetail(detail.id, true);
                    }
                  }).catch(function (err) {
                    console.error('保存失败:', err);
                    _this16.$message.error('排序保存失败');
                    // 保存失败时重新拉取原数据
                    _this16.reloadSingleGroupDetail(detail.id, true);
                  });
                }
              }

              // 延迟重置标志
              setTimeout(function () {
                _this16.isDragging = false;
              }, 300);
            }
          });

          // 保存实例引用以便后续销毁
          _this16.sortableInstances[detail.id] = sortableInstance;
          // console.log(`分组 ${detail.id} 的 Sortable 实例已保存，当前实例数量:`, Object.keys(this.sortableInstances).length);
        }
      }
    });
  }), "handleItemDragEnd", function handleItemDragEnd(detail, oldIndex, newIndex) {
    var _this17 = this;
    // console.log('=== 拖动结束 ===', 'oldIndex:', oldIndex, 'newIndex:', newIndex, 'detail.id:', detail.id);

    // 从 templateGroupItems 中找到对应的分组
    var groupIndex = this.templateGroupItems.findIndex(function (d) {
      return d.id === detail.id;
    });
    // console.log('分组索引:', groupIndex, '分组ID:', detail.id);

    if (groupIndex !== -1) {
      // ⚠️ 关键发现：Sortable 在 onEnd 触发时已经更新了 DOM
      // 我们不能使用 oldIndex/newIndex，必须直接读取 DOM 的当前状态！
      var tableRef = this.$refs["table_".concat(detail.id)];
      if (tableRef && tableRef[0]) {
        var tbody = tableRef[0].$el.querySelector('.el-table__body-wrapper tbody');
        if (tbody) {
          // 🔑 关键：使用双重 nextTick 确保 Sortable 完全完成 DOM 操作
          this.$nextTick(function () {
            _this17.$nextTick(function () {
              // console.log('=== 延迟后读取 DOM 顺序 ===');

              // 从 DOM 读取当前的商品 ID 顺序
              var domItemIds = [];
              Array.from(tbody.children).forEach(function (tr, index) {
                var icon = tr.querySelector('.el-icon-rank');
                if (icon && icon.getAttribute('data-id')) {
                  var itemId = icon.getAttribute('data-id');
                  domItemIds.push(itemId);
                  // console.log(`DOM 位置 ${index}: 商品 ${itemId}`);
                }
              });

              // console.log('DOM 读取的商品 ID 顺序:', domItemIds);
              // console.log('Vue data 的商品 ID 顺序:', this.templateGroupItems[groupIndex].items.map(i => i.id));

              // 根据 DOM 顺序重新排列 items 数组
              var items = _this17.templateGroupItems[groupIndex].items;
              var newOrder = [];
              var oldItems = (0, _toConsumableArray2.default)(items); // 复制一份

              // 按DOM顺序重新排列
              domItemIds.forEach(function (id) {
                var item = oldItems.find(function (i) {
                  return i.id === parseInt(id);
                });
                if (item) {
                  newOrder.push(item);
                }
              });
              if (newOrder.length !== items.length) {
                console.error('重建 items 失败！找到的 item 数量不匹配');
                return;
              }

              // console.log('新顺序:', newOrder.map(i => i.id));

              // 检查顺序是否真的改变了
              var currentIds = items.map(function (i) {
                return i.id;
              });
              var newIds = newOrder.map(function (i) {
                return i.id;
              });
              var isOrderChanged = currentIds.some(function (id, index) {
                return id !== newIds[index];
              });
              // console.log('顺序是否改变:', isOrderChanged);

              if (!isOrderChanged) {
                // console.log('顺序没有变化，跳过更新');
              } else {
                // 🔑 关键：原地修改数组，不改变数组引用
                // 这样Vue不会触发完全重新渲染
                items.splice.apply(items, [0, items.length].concat(newOrder));
                // console.log('Vue 数据已原地更新，与 DOM 保持一致');
              }

              // 保存到服务器
              var itemIds = domItemIds.map(function (id) {
                return parseInt(id);
              });
              (0, _menuTemplate.saveGroupItemSort)({
                ids: itemIds
              }).then(function (res) {
                // console.log('API 返回:', res.code, res.msg);
                if (res.code === 0 || res.code === 200) {
                  _this17.$message.success('排序保存成功');
                  // console.log('排序完成，不重新加载分组');
                } else {
                  _this17.$message.error(res.msg || '排序保存失败');
                }
              }).catch(function () {
                _this17.$message.error('排序保存失败');
              });
            });
          });
        }
      }
    }
  }), "onGroupDragEnd", function onGroupDragEnd(draggingNode, dropNode, dropType, ev) {
    var _this18 = this;
    // 调用API保存排序
    var sortedIds = this.dishGroups.map(function (item) {
      return item.id;
    });
    (0, _menuTemplate.saveGroupSort)({
      ids: sortedIds
    }).then(function (res) {
      if (res.code == 0 || res.code == 200) {
        _this18.$message.success('操作成功');
        // 优化：只刷新分组列表（左侧树），不刷新分组详情
        (0, _menuTemplate.getTemplateDishGroup)({
          templateId: _this18.templateId,
          scene: _this18.selectScene
        }).then(function (res) {
          _this18.dishGroups = res.data;
          // console.log('分组列表刷新成功，分组数量:', res.data.length);
        }).catch(function (err) {
          console.error('刷新分组列表失败:', err);
          _this18.$message.error('刷新分组列表失败');
        });
      } else {
        _this18.$message.error(res.msg || '排序保存失败');
      }
    }).catch(function () {
      _this18.$message.error('排序保存失败');
    });
  }), "allowDrag", function allowDrag(draggingNode) {
    // 根节点（全部）不允许拖拽
    return draggingNode.data.id !== 'all';
  }), "allowDrop", function allowDrop(draggingNode, dropNode, type) {
    // 只允许在同一层级内拖拽排序，且不能拖入根节点
    if (dropNode.data.id === 'all' && type === 'inner') {
      return false;
    }
    return type !== 'inner';
  }), "expandAll", function expandAll() {
    // 展开所有节点
    for (var i = 0; i < this.dishGroups.length; i++) {
      var node = this.$refs.groupTree.getNode(this.dishGroups[i].id);
      if (node) {
        node.expand();
      }
    }
    // 展开根节点
    var rootNode = this.$refs.groupTree.getNode('all');
    if (rootNode) {
      rootNode.expand();
    }
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "collapseAll", function collapseAll() {
    // 折叠所有节点
    for (var i = 0; i < this.dishGroups.length; i++) {
      var node = this.$refs.groupTree.getNode(this.dishGroups[i].id);
      if (node) {
        node.collapse();
      }
    }
  }), "handleBatchChangeStatus", function handleBatchChangeStatus(status) {
    var _this19 = this;
    var ids = this.getAllSelectedIds();
    if (ids.length === 0) {
      this.$message.warning('请至少选择一个商品');
      return;
    }
    this.$confirm('确认更新状态吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      (0, _menuTemplate.batchChangeStatus)({
        ids: ids,
        status: status
      }).then(function (res) {
        if (res.code == 0 || res.code == 200) {
          _this19.$message.success('操作成功');
          // 重置全选状态
          _this19.isAllSelected = false;
          _this19.selectedItemsMap = {};
          _this19.selectedItemIds.clear(); // 清空选中的商品ID集合
          _this19.handleSceneSelect();
        } else {
          _this19.$message.error(res.msg || '操作失败');
        }
      }).catch(function () {
        _this19.$message.error('操作失败');
      });
    }).catch(function () {});
  }), "handleSelectionChange", function handleSelectionChange(selectedRows, detail) {
    var _this20 = this;
    // 使用表格的 key（即 detail.id）来区分不同表格的选中项
    this.$set(this.selectedItemsMap, detail.id, selectedRows);

    // 集中管理选中的商品ID
    // 先清空该分组原有商品ID的选中状态
    if (detail.items) {
      detail.items.forEach(function (item) {
        _this20.selectedItemIds.delete(item.id);
      });
    }

    // 添加当前选中的商品ID
    selectedRows.forEach(function (row) {
      _this20.selectedItemIds.add(row.id);
    });

    // 检查是否所有商品都被选中，更新全选状态
    this.checkAllSelectedStatus();
  }), "checkAllSelectedStatus", function checkAllSelectedStatus() {
    var _this21 = this;
    var totalItems = 0;
    var selectedItems = 0;
    this.templateGroupItems.forEach(function (detail) {
      totalItems += detail.items ? detail.items.length : 0;
      var tableRef = _this21.$refs["table_".concat(detail.id)];
      if (tableRef && tableRef.length > 0) {
        selectedItems += tableRef[0].selection.length;
      }
    });
    this.isAllSelected = totalItems > 0 && totalItems === selectedItems;
  }), "getAllSelectedIds", function getAllSelectedIds() {
    // 直接返回selectedItemIds中的ID，这样即使数据未加载也能正确获取选中的ID
    return Array.from(this.selectedItemIds);
  }), "clearAllSelection", function clearAllSelection() {
    var _this22 = this;
    this.selectedItemsMap = {};
    this.selectedItemIds.clear(); // 清空选中的商品ID集合

    // 安全地清空表格实际选中状态
    this.templateGroupItems.forEach(function (detail) {
      var tableRef = _this22.$refs["table_".concat(detail.id)];
      if (tableRef && tableRef.length > 0) {
        tableRef[0].clearSelection();
      }
    });
  }), "saveEntity", function saveEntity() {
    var _this23 = this;
    this.$confirm('确认更新适用场景吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(function () {
      _this23.fullscreenLoading = true;
      (0, _menuTemplate.save)({
        id: _this23.templateId,
        checkedScene: _this23.baseInfo.checkedScene
      }).then(function (res) {
        _this23.fullscreenLoading = false;
        if (res.code === 0 || res.code === 200) {
          _this23.$message.success('操作成功');
          _this23.getBaseInfo();
        } else {
          _this23.$message.error(res.msg || '操作失败');
        }
      }).catch(function () {
        _this23.fullscreenLoading = false;
        _this23.$message.error('操作失败');
      });
    }).catch(function () {});
  }), "handleTableSortChange", function handleTableSortChange(sort, detail) {
    if (!sort || !sort.prop || !sort.order) {
      return;
    }
    var direction = sort.order === 'ascending' ? 1 : -1;
    var prop = sort.prop;
    if (Array.isArray(detail.items)) {
      detail.items = (0, _toConsumableArray2.default)(detail.items).sort(function (a, b) {
        var va = a[prop];
        var vb = b[prop];
        if (va == null && vb == null) return 0;
        if (va == null) return -1 * direction;
        if (vb == null) return 1 * direction;
        if (typeof va === 'number' && typeof vb === 'number') {
          return (va - vb) * direction;
        }
        return String(va).localeCompare(String(vb)) * direction;
      });
    }
  }), "handleGroupDelete", function handleGroupDelete(id) {
    var _this24 = this;
    this.$confirm('确认删除分组吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      (0, _menuTemplate.deleteTemplateDishGroup)(id).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this24.$message.success('操作成功');
          _this24.handleItemAddFilter();
          // 刷新分组列表和模板分组数据
          (0, _menuTemplate.getTemplateDishGroup)({
            templateId: _this24.templateId,
            scene: _this24.selectScene
          }).then(function (res) {
            _this24.dishGroups = res.data;
          });
          _this24.handleGetTemplateGroupItems();
        } else {
          _this24.$message.error(res.msg || '删除失败');
        }
      }).catch(function () {
        _this24.$message.error('删除失败');
      });
    }).catch(function () {});
  }), "handleGroupItemDelete", function handleGroupItemDelete(id) {
    var _this25 = this;
    this.$confirm('确认删除商品吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      (0, _menuTemplate.deleteGroupItem)(id).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this25.$message.success('操作成功');
          _this25.handleItemAddFilter();
          // 刷新当前分组的数据
          _this25.handleGetTemplateGroupItems();
        } else {
          _this25.$message.error(res.msg || '删除失败');
        }
      }).catch(function () {
        _this25.$message.error('删除失败');
      });
    }).catch(function () {});
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "retPage", function retPage() {
    this.handleItemAddFilter();
  }), "handleAddGroupItem", function handleAddGroupItem(groupId) {
    this.itemAddQuery.dataId = groupId;
    this.handleItemAddFilter();
    this.itemAddVisible = true;
  }), "handleAddAll", function handleAddAll() {
    var _this26 = this;
    var tableRef = this.$refs.itemAddTable;
    var selectedRows = tableRef ? tableRef.selection : [];
    if (selectedRows.length === 0) {
      this.$message.warning('请至少选择一个商品');
      return;
    }
    this.$confirm('确认添加选中的商品吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      var promises = selectedRows.map(function (row) {
        return (0, _menuTemplate.saveGroupItem)({
          goodsId: row.id,
          templateGroupId: _this26.itemAddQuery.dataId
        });
      });
      Promise.all(promises).then(function (results) {
        var successCount = results.filter(function (res) {
          return res.code === 0 || res.code === 200;
        }).length;
        if (successCount === selectedRows.length) {
          _this26.$message.success('添加成功');
          _this26.handleGetTemplateGroupItems();
          _this26.itemAddVisible = false;
        } else if (successCount > 0) {
          _this26.$message.warning("\u6279\u91CF\u6DFB\u52A0\u90E8\u5206\u6210\u529F\uFF0C\u6210\u529F ".concat(successCount, " \u4E2A\uFF0C\u5931\u8D25 ").concat(selectedRows.length - successCount, " \u4E2A"));
          _this26.handleGetTemplateGroupItems();
        } else {
          _this26.$message.error('添加失败');
        }
      }).catch(function () {
        _this26.$message.error('添加失败');
      });
    }).catch(function () {});
  }), "handleItemAddFilter", function handleItemAddFilter() {
    var _this27 = this;
    this.listLoading = true;
    (0, _goods.queryList)(this.itemAddQuery).then(function (response) {
      if (response) {
        _this27.itemAddData = response.records;
        _this27.itemAddTotal = response.total;
      }
      setTimeout(function () {
        _this27.listLoading = false;
      }, 0.5 * 1000);
    }, function () {
      setTimeout(function () {
        _this27.listLoading = false;
      }, 0.5 * 1000);
    });
  }), "addGoods", function addGoods(goodsId) {
    var _this28 = this;
    this.$confirm('确认添加此商品吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      (0, _menuTemplate.saveGroupItem)({
        goodsId: goodsId,
        templateGroupId: _this28.itemAddQuery.dataId
      }).then(function (res) {
        _this28.listLoading = false;
        if (res.code === 0 || res.code === 200) {
          _this28.$message.success('操作成功');
          // 刷新当前分组的数据
          _this28.handleGetTemplateGroupItems();
          // 关闭添加商品对话框
          _this28.itemAddVisible = false;
        } else {
          _this28.$message.error(res.msg || '添加失败');
        }
      }).catch(function () {
        _this28.listLoading = false;
        _this28.$message.error('添加失败');
      });
    }).catch(function () {});
  }), "handleStatusChange", function handleStatusChange(value, row) {
    var _this29 = this;
    this.listLoading = true;
    (0, _menuTemplate.saveGroupItem)({
      id: row.id,
      status: value
    }).then(function (res) {
      _this29.listLoading = false;
      if (res.code === 0 || res.code === 200) {
        _this29.$message.success('操作成功');
      } else {
        _this29.$message.error(res.msg || '操作失败');
      }
    }).catch(function () {
      _this29.listLoading = false;
      _this29.$message.error('操作失败');
    });
  }), "handleGetTemplateGroupItems", function handleGetTemplateGroupItems(id) {
    var _this30 = this;
    this.templateGroupItems = [];
    var params = {
      templateId: this.templateId,
      scene: this.selectScene
    };
    // 只有当 id 不是 'all' 时才传递 id 参数
    if (id && id !== 'all') {
      params.id = id;
    }

    // 首次只加载分组信息和商品ID
    (0, _menuTemplate.getTemplateGroupsWithItemIds)(params).then(function (res) {
      // 清理所有 Sortable 实例
      Object.keys(_this30.sortableInstances).forEach(function (groupId) {
        if (_this30.sortableInstances[groupId]) {
          _this30.sortableInstances[groupId].destroy();
        }
      });
      _this30.sortableInstances = {};
      _this30.templateGroupItems = res.data;
      _this30.loadedGroupIds.clear(); // 清空已加载记录
      _this30.loadingGroupIdsMap = {}; // 重置所有分组的加载状态

      // 数据更新后初始化可见性监听和拖拽
      _this30.$nextTick(function () {
        _this30.initIntersectionObserver();
        _this30.templateGroupItems.forEach(function (detail) {
          // 只为已加载详情的分组初始化拖拽
          if (_this30.loadedGroupIds.has(detail.id)) {
            _this30.initDraggableForTable(detail);
          }
        });
      });
    });
  }), "addGroup", function addGroup(groupId) {
    var _this31 = this;
    this.$confirm('确认添加此分组吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      (0, _menuTemplate.addTemplateDishGroup)({
        templateId: _this31.templateId,
        groupId: groupId,
        scene: _this31.selectScene
      }).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this31.$message.success('添加成功');
          _this31.handleGroupAddFilter();
          // 刷新分组列表和模板分组数据
          (0, _menuTemplate.getTemplateDishGroup)({
            templateId: _this31.templateId,
            scene: _this31.selectScene
          }).then(function (res) {
            _this31.dishGroups = res.data;
          });
          _this31.handleGetTemplateGroupItems();
          // 关闭添加分组对话框
          _this31.groupAddVisible = false;
        } else {
          _this31.$message.error(res.msg || '添加失败');
        }
      }).catch(function () {
        _this31.$message.error('添加失败');
      });
    }).catch(function () {});
  }), "handleBatchAddGroup", function handleBatchAddGroup() {
    var _this32 = this;
    var tableRef = this.$refs.groupAddTable;
    var selectedRows = tableRef ? tableRef.selection : [];
    if (selectedRows.length === 0) {
      this.$message.warning('请至少选择一个分组');
      return;
    }
    this.$confirm('确认批量添加选中的分组吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(function () {
      var groupIds = selectedRows.map(function (row) {
        return row.id;
      });
      (0, _menuTemplate.batchAddTemplateDishGroup)({
        templateId: _this32.templateId,
        groupIds: groupIds,
        scene: _this32.selectScene
      }).then(function (res) {
        if (res.code === 0 || res.code === 200) {
          _this32.$message.success('批量添加成功');
          _this32.handleGroupAddFilter();
          // 刷新分组列表和模板分组数据
          (0, _menuTemplate.getTemplateDishGroup)({
            templateId: _this32.templateId,
            scene: _this32.selectScene
          }).then(function (res) {
            _this32.dishGroups = res.data;
          });
          _this32.handleGetTemplateGroupItems();
          // 关闭添加分组对话框
          _this32.groupAddVisible = false;
        } else {
          _this32.$message.error(res.msg || '批量添加失败');
        }
      }).catch(function () {
        _this32.$message.error('批量添加失败');
      });
    }).catch(function () {});
  }), "handleGroupAddFilter", function handleGroupAddFilter() {
    var _this33 = this;
    this.listLoading = true;
    (0, _dishGroup.queryList)({
      dataType: 'menuTemplate',
      dataId: this.templateId,
      scene: this.selectScene,
      keywords: this.groupAddQuery.keywords,
      limit: 1000
    }).then(function (res) {
      _this33.groupAddData = res.records;
      _this33.listLoading = false;
    });
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "handleGroupAddVisible", function handleGroupAddVisible() {
    this.handleGroupAddFilter();
    this.groupAddVisible = true;
  }), "handleGroupSelectAll", function handleGroupSelectAll() {
    this.handleGetTemplateGroupItems();
  }), "handleGroupSelect", function handleGroupSelect(data, node) {
    var _this34 = this;
    this.selectGroup = data.id;
    // 如果点击的是"全部"，则查询所有数据
    if (data.id === 'all') {
      this.handleGetTemplateGroupItems();
    } else {
      // 否则滚动到对应的分组
      this.$nextTick(function () {
        var targetElement = document.getElementById("group-block-".concat(data.id));
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          // 添加高亮效果
          targetElement.classList.add('group-block-highlight');
          setTimeout(function () {
            targetElement.classList.remove('group-block-highlight');
          }, 2000);

          // 强制加载该分组的详情（避免等待 Intersection Observer）
          if (!_this34.loadedGroupIds.has(data.id)) {
            // console.log(`点击分组树，强制加载分组 ${data.id} 的详情`);
            _this34.loadGroupDetails(data.id);
          }
        } else {
          // console.warn(`未找到分组 ${data.id} 的DOM元素`);
        }
      });
    }
  }), "handleSceneSelect", function handleSceneSelect(key, keyPath) {
    var _this35 = this;
    if (key) {
      this.selectScene = key;
    }
    (0, _menuTemplate.getTemplateDishGroup)({
      templateId: this.templateId,
      scene: this.selectScene
    }).then(function (res) {
      _this35.dishGroups = res.data;
    });
    this.handleGetTemplateGroupItems();
  }), "getBaseInfo", function getBaseInfo() {
    var _this36 = this;
    (0, _menuTemplate.getById)(this.templateId).then(function (res) {
      _this36.baseInfo = res.data;
      // 初始化选中的场景，从baseInfo.checkedScene复制到selectedScenes
      _this36.selectedScenes = (0, _toConsumableArray2.default)(_this36.baseInfo.checkedScene || []);

      // 如果控制块中有勾选的场景，默认选中第一个
      if (_this36.selectedScenes.length > 0) {
        _this36.handleSceneSelect(_this36.selectedScenes[0]);
      }
    });
  }), "handleSceneControlChange", function handleSceneControlChange(selectedValues) {
    this.selectedScenes = selectedValues;
    // 如果当前选中的场景不在新的选中列表中，清空当前选择
    if (this.selectScene && !this.selectedScenes.includes(this.selectScene)) {
      this.selectScene = null;
      this.dishGroups = [];
      this.templateGroupItems = [];
    }

    // 如果控制块中有勾选的场景且当前没有选中任何场景，自动选中第一个
    if (this.selectedScenes.length > 0 && !this.selectScene) {
      this.handleSceneSelect(this.selectedScenes[0]);
    }
  }), "handleSyncMenu", function handleSyncMenu() {
    this.syncMenuVisible = true;
  }), "handleSelectAll", function handleSelectAll() {
    var _this37 = this;
    this.isAllSelected = !this.isAllSelected;
    if (this.isAllSelected) {
      // 全选时，需要先确保所有分组都已加载详情
      this.templateGroupItems.forEach(function (detail) {
        // 如果分组详情未加载，先加载
        if (!_this37.loadedGroupIds.has(detail.id)) {
          _this37.loadGroupDetails(detail.id);
        }
      });

      // 等待所有数据加载完成后进行选中
      this.$nextTick(function () {
        setTimeout(function () {
          _this37.templateGroupItems.forEach(function (detail) {
            var tableRef = _this37.$refs["table_".concat(detail.id)];
            if (tableRef && tableRef.length > 0 && detail.items) {
              detail.items.forEach(function (row) {
                tableRef[0].toggleRowSelection(row, true);
              });
            }
          });
          _this37.$message.success('已选中所有菜品');
        }, 500); // 给予一定时间让数据加载
      });
    } else {
      this.clearAllSelection();
      this.$message.success('已取消全选');
    }
  }), "handlePreviewTemplate", function handlePreviewTemplate() {
    if (!this.selectScene) {
      this.$message.warning('请先选择场景');
      return;
    }
    this.previewDialogVisible = true;
    this.previewLoading = true;
    this.previewQrCode = '';

    // 调用后端接口生成预览二维码
    this.generatePreviewQrCode();
  }), "generatePreviewQrCode", function generatePreviewQrCode() {
    var _this38 = this;
    // 构建预览URL参数
    var params = {
      templateId: this.templateId,
      scene: this.selectScene
    };

    // 调用后端接口获取小程序码或二维码URL
    (0, _menuTemplate.generateMenuPreviewQrCode)(params).then(function (res) {
      // 兼容code为0或200的情况
      if ((res.code === 0 || res.code === 200) && res.data) {
        _this38.previewQrCode = res.data;
        _this38.previewLoading = false;
      } else {
        _this38.$message.error('生成二维码失败');
        _this38.previewLoading = false;
      }
    }).catch(function () {
      _this38.$message.error('生成二维码失败');
      _this38.previewLoading = false;
    });
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "downloadQrCode", function downloadQrCode() {
    if (!this.previewQrCode) {
      this.$message.warning('二维码未生成');
      return;
    }

    // 创建一个临时的a标签来下载图片
    var link = document.createElement('a');
    link.href = this.previewQrCode;
    link.download = "\u6A21\u677F\u9884\u89C8_".concat(this.baseInfo.name, "_").concat(this.getSceneLabel(this.selectScene), ".png");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }), "downloadAllStoreQrCodes", function () {
    var _downloadAllStoreQrCodes2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var params, response, fileName, _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (this.selectScene) {
              _context.next = 1;
              break;
            }
            this.$message.warning('请先选择场景');
            return _context.abrupt("return");
          case 1:
            _context.prev = 1;
            this.downloadAllLoading = true;
            this.$message.info('正在生成所有门店预览码，请稍候...');

            // 调用后端接口批量生成并下载
            params = {
              templateId: this.templateId,
              scene: this.selectScene
            };
            _context.next = 2;
            return (0, _menuTemplate.downloadAllStoreQrCodes)(params);
          case 2:
            response = _context.sent;
            // 生成默认文件名
            fileName = "".concat(this.baseInfo.name, "_").concat(this.getSceneLabel(this.selectScene), "_\u95E8\u5E97\u9884\u89C8\u7801.zip"); // 直接使用响应数据作为blob下载
            // 当responseType为'blob'时，axios会自动将响应转换为Blob对象
            (0, _fileSaver.saveAs)(response, fileName);
            this.$message.success('下载成功');
            _context.next = 4;
            break;
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            console.error('下载门店预览码失败:', _t);
            this.$message.error('下载失败: ' + (_t.message || '未知错误'));
          case 4:
            _context.prev = 4;
            this.downloadAllLoading = false;
            return _context.finish(4);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, this, [[1, 3, 4, 5]]);
    }));
    function downloadAllStoreQrCodes() {
      return _downloadAllStoreQrCodes2.apply(this, arguments);
    }
    return downloadAllStoreQrCodes;
  }()), "handleGenerateTotalQrCode", function () {
    var _handleGenerateTotalQrCode = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var params, res, _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (this.selectScene) {
              _context2.next = 1;
              break;
            }
            this.$message.warning('请先选择场景');
            return _context2.abrupt("return");
          case 1:
            _context2.prev = 1;
            this.totalQrCodeLoading = true;
            this.$message.info('正在生成总预览码，请稍候...');

            // 调用后端接口生成总预览码
            params = {
              templateId: this.templateId,
              scene: this.selectScene,
              type: 'total' // 标识为总预览码
            };
            _context2.next = 2;
            return (0, _menuTemplate.generateMenuPreviewQrCode)(params);
          case 2:
            res = _context2.sent;
            // 兼容code为0或200的情况
            if ((res.code === 0 || res.code === 200) && res.data) {
              this.totalQrCode = res.data;
              this.$message.success('生成成功，正在下载...');

              // 下载总预览码
              this.downloadTotalQrCode();
            } else {
              this.$message.error('生成总预览码失败');
            }
            _context2.next = 4;
            break;
          case 3:
            _context2.prev = 3;
            _t2 = _context2["catch"](1);
            console.error('生成总预览码失败:', _t2);
            this.$message.error('生成失败: ' + (_t2.message || '未知错误'));
          case 4:
            _context2.prev = 4;
            this.totalQrCodeLoading = false;
            return _context2.finish(4);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this, [[1, 3, 4, 5]]);
    }));
    function handleGenerateTotalQrCode() {
      return _handleGenerateTotalQrCode.apply(this, arguments);
    }
    return handleGenerateTotalQrCode;
  }()), "downloadTotalQrCode", function downloadTotalQrCode() {
    if (!this.totalQrCode) {
      this.$message.warning('总预览码未生成');
      return;
    }

    // 创建一个临时的a标签来下载图片
    var link = document.createElement('a');
    link.href = this.totalQrCode;
    link.download = "\u603B\u9884\u89C8\u7801_".concat(this.baseInfo.name, "_").concat(this.getSceneLabel(this.selectScene), ".png");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }), "debugLoadingStatus", function debugLoadingStatus() {
    var _this39 = this;
    // console.log('=== 懒加载状态调试信息 ===');
    // console.log('总分组数:', this.templateGroupItems.length);
    // console.log('已加载分组数:', this.loadedGroupIds.size);
    // console.log('已加载分组ID:', Array.from(this.loadedGroupIds));
    // console.log('未加载分组:', this.templateGroupItems
    //   .filter(function(d) { return !this.loadedGroupIds.has(d.id); }.bind(this))
    //   .map(function(d) { return { id: d.id, name: d.groupName, itemCount: (d.items && d.items.length) || 0 }; })
    // );
    // console.log('滚动容器:', this.scrollContainer);
    // console.log('Observer:', this.observer);
    // console.log('========================');

    return this.templateGroupItems.filter(function (d) {
      return !_this39.loadedGroupIds.has(d.id);
    });
  }))
};